import Modal, { MODAL_WIDTH } from '@root/gatsby-contentful-core/src/components/modal';
import PropTypes from '@root/vendor/prop-types';
import React from '@root/vendor/react';
import { StyleSheet, Theme } from '@root/core/src/utils/styles';

export const AGENCY_ONBOARDING_MODAL_NAME = 'agency-onboarding-modal';

export default function AgencyOnboardingModalShell({
  children,
  footer,
  isShowing,
  modalName = AGENCY_ONBOARDING_MODAL_NAME,
  onClose = () => {},
  renderCloseButton = true,
  subtitle = 'Personal lines auto appointments only.',
  title = 'Become an Appointed Agent with Root Insurance.',
}) {
  return (
    <Modal
      isShowing={isShowing}
      modalWidth={MODAL_WIDTH.Large}
      name={modalName}
      onClose={onClose}
      renderCloseButton={renderCloseButton}
    >
      <div css={styles.content}>
        <div css={styles.header}>
          <h2 css={styles.title}>{title}</h2>
          {subtitle && <p css={styles.subtitle}>{subtitle}</p>}
        </div>

        {children &&
          <div
            css={styles.body}
            data-testid={'agency-onboarding-modal-body'}
          >
            {children}
          </div>
        }

        {footer &&
          <div css={styles.footer}>
            {footer}
          </div>
        }
      </div>
    </Modal>
  );
}

AgencyOnboardingModalShell.propTypes = {
  children: PropTypes.node,
  footer: PropTypes.node,
  isShowing: PropTypes.bool,
  modalName: PropTypes.string,
  onClose: PropTypes.func,
  renderCloseButton: PropTypes.bool,
  subtitle: PropTypes.string,
  title: PropTypes.string,
};

const styles = StyleSheet.create({
  content: {
    width: '100%',
    maxWidth: 740,
    margin: '0 auto',
    display: 'flex',
    flexDirection: 'column',
    gap: 24,
  },
  header: {
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
  },
  title: {
    ...Theme.heading1(),
    margin: 0,
  },
  subtitle: {
    ...Theme.paragraph1(),
    margin: 0,
  },
  body: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
  },
  footer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 12,
  },
});
